<template>
	<section class="container">
		<div class="lay">
			<div class="row">
				<left-menu></left-menu>
				<div class="row-item row-item_content">
					<article>
						<ul class="submenu">
							<li class="submenu-item">
								<a
									class="submenu-itemLink"
									:class="section === 0 ? 'nuxt-link-active' : ''"
									@click.prevent="section = 0"
									href="#"
								>
									Услуги экспертов
								</a>
							</li>
							<li class="submenu-item" v-if="subscriptions.length > 0">
								<a
									class="submenu-itemLink"
									:class="section === 1 ? 'nuxt-link-active' : ''"
									@click.prevent="section = 1"
									href="#"
								>
									Покупка абонемента
								</a>
							</li>
						</ul>
						<template v-if="section === 0">
							<h2>Выберите услугу</h2>
							<div class="list">
								<div v-if="items.length === 0">
									В настоящий момент нет услуг выбранного направления.
								</div>
								<div
									class="list-item"
									:class="services_id === item.id ? 'list-item_active' : ''"
									v-for="item in items"
									:key="item.id"
								>
									<div class="list-itemWrapper" @click="selectService(item)">
										<div class="list-itemName">{{ item.name }}</div>
										<div class="list-itemPrice">
											{{ priceRange(item) }} руб.
										</div>
									</div>
									<template v-if="services_id === item.id && item.description">
										<div v-html="item.description" class="list-itemDescription"></div>
									</template>
									<div
										class="list-itemNotFound"
										v-if="sessions.length === 0 && services_id === item.id"
									>
										Свободных сеансов выбранной услуги не найдено.
									</div>
									<workers
										ref="workers"
										v-if="services_id === item.id"
										:items="sessions"
										:workers_id="schedule.workers_id"
										@input="schedule.workers_id = $event"
										:anychoice="item.anychoice !== '0'"
									>
										<schedule
											v-if="services_id === item.id"
											v-model="schedule"
											type="1"
											class="sch_inworkers"
											:count="schedule.count"
											:sessions="$store.state.schedule.sessions"
											:workers_id="schedule.workers_id"
											:services_id="services_id"
											@dateChange="dateChange"
										></schedule>
									</workers>
								</div>
							</div>
						</template>
						<template v-if="section === 1">
							<h2>Выберите абонемент</h2>
							<div class="list">
								<div
									class="list-item"
									v-for="item in subscriptions"
									:key="item.id"
									:class="subscriptions_id === item.id ? 'list-item_active' : ''"
								>
									<div class="list-itemWrapper" @click="selectSubscription(item)">
										<div class="list-itemName">{{ item.name }}</div>
										<div class="list-itemPrice">{{ priceFormat(item.price) }} руб.</div>
									</div>
									<div class="list-itemText" v-if="subscriptions_id === item.id">
										{{ item.text }}
										<div v-if="item.count > 0">Число использований: {{ item.count }}</div>
										<div v-if="item.duration > 0">Предоставляется на: {{ item.duration }} дней</div>
										<div v-if="item.prepay > 0">
											Включает в себя: {{ item.prepay }} предоплаченных часов
										</div>
										<br />
										<div class="button" @click="order(item)">
											<span>Купить онлайн</span>
										</div>
									</div>
								</div>
							</div>
						</template>
					</article>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import helper from '@/plugins/helper.js';
import schedule from '@/components/schedule.vue';
import leftMenu from '@/components/leftmenu.vue';
import workers from '@/components/workers.vue';
import { mapState } from 'vuex';
import _ from 'lodash';

let defaults = {
	date: new Date(),
	count: 5,
	workers_id: '0',
};
export default {
	components: {
		schedule,
		leftMenu,
		workers,
	},
	data() {
		return {
			schedule: defaults,
			section: 0,
			services_id: null,
			subscriptions_id: null,
		};
	},
	computed: {
		//...mapState('subscriptions', { subscriptions: 'items' }),
		items() {
			return this.$store.state.services.items;
		},
		sessions() {
			return this.$store.state.schedule.sessions;
		},
		subscriptions() {
			return this.$store.state.subscriptions.items.filter(item => item.hidden !== '1');
		},
	},
	async fetch({ store, route }) {
		return await store.dispatch('init', { route });
	},
	methods: {
		selectService({ id }) {
			const data = {
				date: helper.dateFormat(defaults.date),
				type: '1',
				services_id: id,
			};
			this.schedule.workers_id = '0';
			this.$store
				.dispatch('api/send', {
					task: 'checkSessionsExists',
					data: { ...data, count: 21 },
				})
				.then(res => {
					if (res[0] && res[0].data && res[0].data.exists === true) {
						this.$store
							.dispatch('api/send', {
								task: 'getSessions',
								data: { ...data, count: 5 },
							})
							.then(async () => {
								this.services_id = id;
								await this.$router.push({ query: { ...this.$route.query, id: this.services_id } });

								if (!this.sessions.length) {
									await this.$store
										.dispatch('api/send', {
											task: 'getSessions',
											data: { ...data, count: 21 },
										});

									await this.$nextTick();
									if (
										this.$refs.workers &&
										this.$refs.workers[0] &&
										this.$refs.workers[0].workers &&
										typeof this.$refs.workers[0].workers[0] === 'undefined'
									) {
										const worker = _.find(this.$refs.workers[0].workers, () => true);
										if (worker) {
											this.schedule.workers_id = worker.id;
										}
									}
								}
							});
					} else {
						this.$store.commit('schedule/setSessions', []);
						this.services_id = id;
						this.$router.push({ query: { ...this.$route.query, id: id } });
					}
				});
		},
		selectSubscription({ id }) {
			this.subscriptions_id = id;
			this.$router.push({
				params: this.$route.params,
				query: { ...this.$route.query, view: 'subscriptions', sid: id },
			});
		},
		dateChange(date) {
			this.$store.dispatch('api/send', {
				task: 'getSessionsBring',
				data: {
					date: helper.dateFormat(date),
					count: 1,
					type: '1',
					services_id: this.services_id,
				},
			});
		},
		priceFormat(value) {
			return helper.priceFormat(value);
		},
		priceRange(item) {
			if (this.schedule.workers_id > 0 && item.prices[this.schedule.workers_id] && this.services_id === item.id)
				return helper.priceFormat(item.prices[this.schedule.workers_id]);

			const prices = Object.entries(item.prices).map(([,value]) => parseInt(value));
			const min = Math.min(...prices, item.price);
			const max = Math.max(...prices, item.price);
			return min !== max ? helper.priceFormat(min) + ' - ' + helper.priceFormat(max) : helper.priceFormat(min);
		},
		order({ id }) {
			this.$store.dispatch('api/send', {
				task: 'order',
				data: {
					type: '1', //оплата абонемента
					id: id,
				},
			});
		},
	},
	created() {
		if (this.$route.query.id) {
			this.selectService({ id: this.$route.query.id });
		}
		if (this.$route.query.sid) {
			this.subscriptions_id = this.$route.query.sid;
		}
		if (this.$route.query.view) {
			if (this.$route.query.view === 'subscriptions') this.section = 1;
		}
	},
	watch: {
		section() {
			if (this.section === 0) {
				this.$router.push({
					query: {
						...this.$route.query,
						view: undefined,
						id: this.services_id || undefined,
						sid: undefined,
						date: undefined,
					},
				});
			}
			if (this.section === 1) {
				this.$router.push({
					query: {
						...this.$route.query,
						view: 'subscriptions',
						id: undefined,
						sid: this.subscriptions_id || undefined,
						date: undefined,
					},
				});
			}
		},
	},
};
</script>
